export default __webpack_public_path__ + "static/undraw_privacy_protection_nlwy-dd5c51ba8df0089c68767c66000cfbf9.svg";